import React from 'react';
import AbstractIcon from './AbstractIcon';
var Icon = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentcolor",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4.21911 21.3753C3.8741 21.8066 3.94402 22.4359 4.37528 22.7809C4.80654 23.1259 5.43583 23.056 5.78084 22.6247L13.7808 12.6247C14.073 12.2595 14.073 11.7405 13.7808 11.3753L5.78085 1.37531C5.43584 0.944049 4.80655 0.874128 4.37528 1.21914C3.94402 1.56415 3.8741 2.19344 4.21911 2.6247L11.7194 12L4.21911 21.3753Z M12.2191 21.3753C11.8741 21.8066 11.944 22.4359 12.3753 22.7809C12.8065 23.1259 13.4358 23.056 13.7808 22.6247L21.7808 12.6247C22.073 12.2595 22.073 11.7405 21.7808 11.3753L13.7808 1.37531C13.4358 0.944049 12.8065 0.874128 12.3753 1.21914C11.944 1.56415 11.8741 2.19344 12.2191 2.6247L19.7194 12L12.2191 21.3753Z"
  }));
});
var NavigationChevronDoubleRight = AbstractIcon.withComponent(Icon);
NavigationChevronDoubleRight.displayName = 'NavigationChevronDoubleRight';
export default NavigationChevronDoubleRight;